import useSWR from "swr"
import API from "./api"

import { useContext } from "react"
import { TLOContext } from "web/contexts"

import { pluralize } from "web/services/inflector"

export default function useTLORecordingEvents() {
  const { subjectType, data } = useContext(TLOContext)

  const { data: events } = useSWR(
    `/${pluralize(subjectType)}/${data.id}/events`,
    API.get,
    {
      suspense: true,
    }
  )

  return events
}
